import { render, staticRenderFns } from "./winBulletinList.vue?vue&type=template&id=72208602&scoped=true"
import script from "./winBulletinList.vue?vue&type=script&lang=js"
export * from "./winBulletinList.vue?vue&type=script&lang=js"
import style0 from "./winBulletinList.vue?vue&type=style&index=0&id=72208602&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72208602",
  null
  
)

export default component.exports